// extracted by mini-css-extract-plugin
module.exports = {"shoppingCartWarp":"index_shoppingCartWarp__GtAmw","shoppingCartBtnIcon":"index_shoppingCartBtnIcon__1YQ_U","large":"index_large__mdr4M","searchInput":"index_searchInput__1G_xV"};